// extracted by mini-css-extract-plugin
export var videoContainer = "_jp-0";
export var videoIframe = "_jp-3";
export var videoLink = "_jp-1";
export var videoOverlay = "_jp-4";
export var videoOverlayText = "_jp-5";
export var videoWrapper = "_jp-2";